















import { Vue, Component, Prop } from 'vue-property-decorator';
import { debounce } from 'lodash';
import * as api from '@/api';

/**
 * 用户搜索框
 *
 * @author liyuyao
 * @date 04/22/2019
 */
@Component({
    components: {}
})
export default class SearchUserDropdown extends Vue {
    @Prop({ default: '请输入抄送人姓名或mis号' })
    placeholder: '';

    @Prop({ default: 'bottom-end' })
    placement: '';

    targetUser: string = '';
    userList: any = [];
    userLoading: boolean = false;
    debounceRemoteMethod: Function = debounce(this.remoteMethod, 200);

    async remoteMethod(query) {
        if (query.trim().length < 1) {
            this.userList = [];
            return;
        }
        this.userLoading = true;
        try {
            const res = await api.rgApi.searchUser({ keyword: query });
            this.userList = res.data.items;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.userLoading = false;
    }
    userItemClick(username, displayName) {
        // 选中后清空搜索记录
        this.userList = [];
        this.targetUser = '';
        this.$emit('change', username, displayName);
    }
}
